import {useState, useEffect, useCallback} from 'react';

import {Nut_Settings_User} from 'nutshell-core/settings-constants';

import {useUpdateSetting} from '../../core/use-update-setting';

export function useCoreEntityWorkspaceSidebarCollapsed(
    isSidebarCollapsed: boolean,
    entityType: 'contact' | 'account' | 'lead'
) {
    const [isWorkspaceSidebarCollapsed, setIsWorkspaceSidebarCollapsed] =
        useState<boolean>(isSidebarCollapsed);
    const updateSetting = useUpdateSetting();

    useEffect(() => {
        setIsWorkspaceSidebarCollapsed(isSidebarCollapsed);
    }, [isSidebarCollapsed]);

    const handleModeChange = useCallback(
        (collapsed: boolean) => {
            setIsWorkspaceSidebarCollapsed(collapsed);

            let settingName = '';
            if (entityType === 'contact') {
                settingName = Nut_Settings_User.SETTING_CONTACT_WORKSPACE_SIDEBAR_COLLAPSED;
            } else if (entityType === 'account') {
                settingName = Nut_Settings_User.SETTING_ACCOUNT_WORKSPACE_SIDEBAR_COLLAPSED;
            } else if (entityType === 'lead') {
                settingName = Nut_Settings_User.SETTING_LEAD_WORKSPACE_SIDEBAR_COLLAPSED;
            }

            if (settingName) {
                updateSetting({
                    settingName,
                    value: collapsed ? '1' : '0',
                    isGlobal: false,
                });
            }
        },
        [entityType, updateSetting]
    );

    return {
        isWorkspaceSidebarCollapsed,
        handleModeChange,
    };
}
